/** 从 localStorage 恢复 Vuex，须在 hydration 之后执行，避免顶栏等与 SSR DOM 不一致 */
function restoreStoreFromLocalStorage(app) {
  try {
    const raw = localStorage.getItem("storeState")
    if (!raw) {
      return
    }
    const saved = JSON.parse(raw)
    if (!saved || typeof saved !== "object") {
      return
    }
    app.store.replaceState(Object.assign(app.store.state, saved))
  } catch (e) {
    // 缓存损坏时忽略
  }
}

export default function (app) {
  if (process.client) {
    window.onNuxtReady(() => {
      restoreStoreFromLocalStorage(app)
    })
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      app.store.state.isLogin = Boolean(app.store.state.isLogin)
      app.store.state.report = false
      localStorage.setItem("storeState", JSON.stringify(app.store.state))
    })
  }
}
